import LogoIcon from "./LogoIcon"

export default function LogoFull({ textColor = "text" }) {
  return (
    <div className="w-[full] flex items-center gap-1.5">
      <div className="w-[26px] lg:w-9 flex items-center shrink-0">
        <LogoIcon />
      </div>

      <span className={`text-${textColor} text-lg lg:text-xl`}>
        Aldoo
        <span className="text-primary font-extrabold">Snap</span>
      </span>
    </div>
  )
}
